export default "__VITE_ASSET__BbtAS6jI__"